/* Optional browser navigation. This is not an HTTP redirect. */
(() => {
  const marker = document.querySelector('[data-tce-product-destination]');
  if (!marker || marker.dataset.enabled !== 'true') return;
  const current = new URL(window.location.href);
  // Never navigate an editor or theme preview to a published storefront.
  if (window.Shopify?.designMode || current.searchParams.has('preview_theme_id')) return;
  const destination = new URL(marker.dataset.tceProductDestination, current.origin);
  const allowedHosts = new Set([
    'www.torontocommercialrefrigeration.ca',
    'torontocommercialicemachines.ca',
    'torontocommercialdishwashers.ca'
  ]);
  if (destination.protocol !== 'https:' || !allowedHosts.has(destination.hostname)) return;
  if (!destination.pathname.includes('/products/')) return;
  if (current.origin === destination.origin) return;
  // Same exact Shopify record; retain selection and attribution, never cart data.
  for (const [key, value] of current.searchParams) {
    if (key === 'variant' || key.startsWith('utm_') || ['gclid', 'gbraid', 'wbraid', 'msclkid'].includes(key)) {
      destination.searchParams.append(key, value);
    }
  }
  destination.hash = current.hash;
  window.location.replace(destination.href);
})();
